
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruiters",
      function () {
        return require("private-next-pages/recruiters/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruiters"])
      });
    }
  